import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['taskListContainer', 'contentPageContainer']

  connect() {
    this.boundHighlightCardHandler = this._highlightCard.bind(this);
    this.boundSyncHandler = this._highlightCardOnSync.bind(this);

    if (this.hasTaskListContainerTarget) {
      this.taskListContainerTarget.addEventListener('promote:highlight-content-page-card', this.boundHighlightCardHandler);
    }

    document.addEventListener('promote:highlight-content-page-card-on-sync', this.boundSyncHandler);
  }

  disconnect() {
    if (this.hasTaskListContainerTarget) {
      this.taskListContainerTarget.removeEventListener('promote:highlight-content-page-card', this.boundHighlightCardHandler);
    }

    document.removeEventListener('promote:highlight-content-page-card-on-sync', this.boundSyncHandler);
  }

  toggleCardHighlight() {
    this.taskListContainerTarget.classList.toggle('open');
    this.contentPageContainerTarget.classList.toggle('js-highlight-static');

    if (this.taskListContainerTarget.classList.contains('open')) {
      this._dispatchAddCardHighlightEvent(this.contentPageContainerTarget);
    } else {
      this._dispatchRemoveCardHighlightEvent();
    }
  }

  _highlightCard(event) {
    this.taskListContainerTarget.classList.add('open');
    this.contentPageContainerTarget.classList.add('js-highlight-static');

    const scroll = event.detail?.scroll ?? true;
    this._dispatchAddCardHighlightEvent(
      this.contentPageContainerTarget, { scroll }
    );
  }

  _highlightCardOnSync() {
    // The event is on document level so we should only update the synced card
    if (event.detail.contentPageId !== this._contentPageTargetId()) {
      return;
    }

    // The content page card is replaced on sync so we need to find it and its elements again
    // We need to query for the task list container specifically because if a task is added to a
    // content page without tasks the taskListContainerTarget will not exist before sync
    const syncedTaskList = document.querySelector('.js-overview-task-list-top');

    if (syncedTaskList && syncedTaskList.querySelector('[id^="js-overview-task-list-item-"]').checkVisibility()) {
        syncedTaskList.classList.toggle('open');
    }

    this._dispatchAddCardHighlightEvent(this._contentPageAfterSync());
  }
  
  _contentPageTargetId() {
    return this.contentPageContainerTarget.id.split('-').at(-1);
  }
  
  _contentPageAfterSync() {
    return document.getElementById(this.contentPageContainerTarget.id);
  }

  _dispatchAddCardHighlightEvent(contentPageElement, { scroll = true } = {}) {
    document.dispatchEvent(new CustomEvent('promote:highlight', {
      detail: { element: contentPageElement, scroll }
    }));
  }

  _dispatchRemoveCardHighlightEvent() {
    document.dispatchEvent(new CustomEvent('promote:highlight-removed', {
      detail: { element: this.contentPageContainerTarget }
    }));
  }
}
